// extracted by mini-css-extract-plugin
module.exports = {"menuContacts":"styles_menuContacts__1KdsW","menuBottom":"styles_menuBottom__2NYDY"};